import React from 'react'

import { css } from 'react-emotion'
import { colors } from '../../styles/vars'

import { Constrain } from '../@primitives/constrain'
import { Button } from '../@primitives/button'

const thinCTA = css`
  p {
    margin-top: 0;
    
    @media (min-width: 769px) {
      margin-bottom: 0;
    }
  }
  
  p,
  a {
    
    @media (min-width: 769px) {
      display: inline-block;
    }
  }
  
  a {
  
    &:hover {
      background-color: ${colors.primaryXd};
    }
    
    @media (min-width: 769px) {
      margin-left: 20px;
    }
  }
`

export const ThinCTA = () =>
  <div
    className={thinCTA}
    style={{
      backgroundColor: colors.primaryD
    }}
  >
    <Constrain
      thin
      className={css`
        color: ${colors.white};
      `}
    >
      <div
        className={css`
          padding: 10px;
          text-align: center;
        `}
      >
        <p className="large">
          AVI is your source for valves, instrumentation, actuators, and accessories.
        </p>
        <Button
          to={"http://advancedvalve.net"}
          external
        />
      </div>
    </Constrain>
  </div>


// WEBPACK FOOTER //
// ./src/components/ThinCta/index.js